import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .progress': {
      '&-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        margin: theme.spacing(2, 0, 3),

        '&.completed': {
          '& .progress': {
            '&-chart': {
              color: theme.palette.custom.feedback.positive,
            },
            '&-button': {
              '&--text': {
                opacity: 0,
              },
              '&--icon': {
                opacity: 1,
                color: theme.palette.custom.feedback.positive,
              },
            },
          },
        },
      },
      '&-chart': {
        boxShadow: `inset 0px 0px 0px 6px ${theme.palette.custom.surface[2]}`,
        borderRadius: '50%',
        color: theme.palette.primary.main,
      },
      '&-button': {
        position: 'absolute',
        '&--text': {
          color: theme.palette.text.hint,
          pointerEvents: 'none',
          transition: theme.transitions.create(),
          position: 'absolute',
        },
        '&--icon': {
          color: theme.palette.text.hint,
          transition: theme.transitions.create(),
          opacity: 0,
        },
        '&:hover': {
          backgroundColor: 'transparent',
          '& .progress-button': {
            '&--text': {
              opacity: 0,
            },
            '&--icon': {
              opacity: 1,
            },
          },
        },
      },
    },
    '& .title': {
      color: theme.palette.text.secondary,
      margin: theme.spacing(0, 4),
    },
    '& .actions-container': {
      justifyContent: 'center',
      margin: theme.spacing(2, 0),
    },
  },
}));

export default styles;
